import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaste = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "var(--main-color)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M18 11V9C18 7.89543 17.1046 7 16 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21H13",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8 7V7C8 7.55228 8.44772 8 9 8H13C13.5523 8 14 7.55228 14 7V7H8Z",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 11,
				cy: 5,
				r: 2,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 11,
				y: 11,
				width: 10,
				height: 10,
				rx: 2,
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 17.5H18",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14 14.5H18",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export { SvgPaste as ReactComponent };
